import React from "react";
import CalendarTimeDisplay from "../../../core/components/timedisplayers/Calendar";
import {SvarReadTypeProps} from "./svarReadTypeCompareMap";

export function DatoReadSvar ({ evalueringSvar } : SvarReadTypeProps) {
    return (
        <div className={"margin-bottom-m"}>
            <CalendarTimeDisplay dato={evalueringSvar.dateSvar}/>
        </div>
    )
}
